
<div @keydown="onKeydown">
  <n-modal-body class="add-recipient-modal" width="m">
    <NTitleBar
      :title="$t('shareSpace.addRecipient')"
      :subtitle="$t('shareSpace.addRecipientSubtitle')"
      closable
      @close="$emit('close')"
      class="title"
      :backButton="!noBackButton"
      :backButtonLabel="$t('general.back')"
      @back="$emit('back')"
    />
    <ValidationObserver ref="form">
      <div class="add-recipient-form">
        <div class="name-form">
          <ValidationProvider rules="required" name="Firstname" v-slot="{ errors }">
            <div class="form-element">
              <n-input
                class="input"
                variableWidth
                autofocus
                v-model="recipient.firstName"
                :label="$t('shareSpace.firstName')"
                :placeholder="$t('shareSpace.john')"
                :error="errors[0]"
              />
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" name="Lastname" v-slot="{ errors }">
            <div class="form-element">
              <n-input
                class="input"
                variableWidth
                v-model="recipient.lastName"
                :label="$t('shareSpace.lastName')"
                :placeholder="$t('shareSpace.doe')"
                :error="errors[0]"
              ></n-input>
            </div>
          </ValidationProvider>
        </div>
        <ValidationProvider rules="required|emailplusimpersonation" name="EmailAddress" v-slot="{ errors }">
          <div class="form-element">
            <n-input
              class="input"
              variableWidth
              v-model="recipient.email"
              :label="$t('shareSpace.emailAddress')"
              :placeholder="$t('shareSpace.johnDoeEmail')"
              :error="errors[0]"
            ></n-input>
          </div>
        </ValidationProvider>
      </div>
    </ValidationObserver>
    <n-modal-footer>
      <template #right>
        <n-button variant="secondary" :label="$t('general.cancel')" @click="$emit('close')" class="margin-right" />
        <n-button @click="addRecipient" icon="check" :label="$t('shareSpace.addRecipient')" :loading="loading" />
      </template>
    </n-modal-footer>
  </n-modal-body>
</div>
